import FileDetails, { openFileDetails } from './FileDetails'
import reducer from './reducers'
import saga from './sagas'
import * as constants from './constants'
import { downloadRemote } from './fileDetails.actions'

export { reducer, saga, constants, downloadRemote, openFileDetails }

export default FileDetails
